import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 开服列表
interface GameOpenListJson {
    section_id?: string | number;
    tag?: string | number;
    versionid?: string | number;
    show_icon?: string | number;
    size?: number;
    page?: number;
}

export const gameOpenList = (json: GameOpenListJson): any =>
    http.httpPost({
        url: httpApi.gameJava.gameOpenList,
        json,
    });
